/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react'
import PropTypes from 'prop-types'

const Spinner = ({ bgColor = '#b8238e', width = 40, height = 40 }) => {
  return (
    <div className="flex justify-center items-center">
      <div
        className={`w-[${width}px] h-[${height}px] border-4 border-[${bgColor}] border-t-transparent rounded-full animate-spin`}
      />
    </div>
  )
}

Spinner.propTypes = {
  bgColor: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
}

export default Spinner
